<template>
  <div class="table-responsive">
    <table :id="table_id" class="display table table-striped table-bordered" style="width:100%; text-align: center;">
      <thead>
        <tr>
          <th style="width: 13% !important">Takaful ID</th>
          <th style="width: 22% !important">Name</th>
          <th style="width: 13% !important">IC Number</th>
          <th style="width: 15% !important">Mobile Number</th>
          <th style="width: 11% !important">Product</th>
          <th style="width: 12% !important">Type</th>
          <th style="width: 14% !important">Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, index) in arrayData" :key="index">
          <td>{{ data.takaful_id }}</td>
          <td>{{ data.name }}</td>
          <td>{{ data.ic_number }}</td>
          <td>{{ data.mobile_number }}</td>
          <td>{{ data.product }}</td>
          <td>{{ data.type }}</td>
          <td>{{ data.purchase_date_formatted }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  props: {
    table_id: {
      type: String,
      default: "table-id"
    },

    arrayData: {
      type: Array,
      default: []
    }


  },

  data() {
    return {

    }
  }
}

</script>
